/**
 * Leave as model: its just a hash of index, string.
 * Can fetch independently of user.
 */

var fvChannel = require('glRadio').channel('FV');

module.exports = Backbone.Model.extend({

    url: function() {
        return fvChannel.request('apiUrl').taskPerms;
    },



    // Export implies ability to download document/pages.
    canExport: function() {
        return _.contains(this.toJSON(), 'EXPORT');
    },
    canDeletePages: function() {
        return _.contains(this.toJSON(), 'DELETE_PAGES');
    },
    // DVBC-1718 -- no longer used
    canViewPdfs: function() {
        return _.contains(this.toJSON(), 'VIEW_PDF');
    },
    canPrint: function() {
        return _.contains(this.toJSON(), 'PRINT');
    },
    /**
     * Determines if the user can 'save' a page rotation;
     * without, user's can rotate pages but it won't be saved.
     * Note: not using -- see allowSaveRotation on document which is now returned
     * in contextual permissions.
     */
    canSavePageRotation: function() {
        return _.contains( this.toJSON(), 'ROTATE' );
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/taskPermsModel.js
 ** module id = 83
 ** module chunks = 0
 **/